import { render, staticRenderFns } from "./TheNavigation.vue?vue&type=template&id=2dcee262&scoped=true&"
import script from "./TheNavigation.vue?vue&type=script&lang=js&"
export * from "./TheNavigation.vue?vue&type=script&lang=js&"
import style0 from "./TheNavigation.vue?vue&type=style&index=0&id=2dcee262&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcee262",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheLogo: require('/opt/build/repo/components/TheLogo.vue').default,SocialList: require('/opt/build/repo/components/SocialList.vue').default,LayoutNavigation: require('/opt/build/repo/components/LayoutNavigation.vue').default})
